import { GetterTree } from 'vuex';
import { AuthState } from './types';
import { RootState } from '../../types';
import {
  vmeSingleCompanyAdminGroup,
  vmeGlobalAdminGroup,
  vmeGlobalAdminGroupId,
  vmeSupportGroup,
  vmeSupportGroupId,
} from '@/shared/backend/account';

export const getters: GetterTree<AuthState, RootState> = {
  /**
   * Answers whether the user is authenticated (an access token is provided).
   */
  // return a function so it is no cached
  ['token']: (state: AuthState) => () => state.token,
  /**
   * Answers the details of the current employee.
   */
  ['user']: (state: AuthState) => state.account,
  ['azureUser']: (state: AuthState) => state.azureData,

  ['isUserInAzureAdminGroup']: (state: AuthState) => state.isUserInAzureAdminGroup,
  ['isUserSupportOrSuperAdmin']: (state: AuthState) => {
    // return !!(
    //   state.userAdminGroups.find((x) => x.displayName == vmeSupportGroup) ||
    //   state.userAdminGroups.find((x) => x.displayName == vmeGlobalAdminGroup)
    // );
    return !!(
      state.userAdminGroups.find((x) => [vmeSupportGroup, vmeGlobalAdminGroup].includes(x.displayName)) ||
      // (AD-62) Use Azure GUID for filtering (displayName is `null` in production for some reason)
      state.userAdminGroups.find((x) => [vmeSupportGroupId, vmeGlobalAdminGroupId].includes(x.id))
    );
  },
  ['isUserSuperAdmin']: (state: AuthState) => {
    return !!(
      state.userAdminGroups.find((x) => x.displayName == vmeGlobalAdminGroup) ||
      // (AD-62) Use Azure GUID for filtering (displayName is `null` in production for some reason)
      state.userAdminGroups.find((x) => x.id == vmeGlobalAdminGroupId)
    );
  },

  isLoggedIn(state): boolean {
    return null != state.account && state.account.id! != '';
  },
  getUser(state): any {
    return state.account;
  },
  getUserId(state): string | null {
    return state.account ? state.account.id! : null;
  },
  getAccountId(state): string | null {
    return state.accountId ? state.accountId! : null;
  },
  isEmailConfirmed(state): boolean {
    return state.account ? state.account.emailConfirmed : false;
  },

  isAdmin(state): boolean {
    return !!state.account && state.account!.authorities && state.account!.authorities!.includes('ADMIN');
  },
  isManager(state): boolean {
    return !!state.account && state.account!.authorities && state.account!.authorities!.includes('MANAGER');
  },
};
